export const SEARCH_RESULT_SIDEBAR_HEIGHT_EVENT = 'searchResultSidebarHeightEvent';
